import { Component, ElementRef, Input, ViewChild, inject } from '@angular/core';
import { AppGlobalsModule } from 'src/app/app-globals.module';
import { BreakPointSizeService } from 'src/app/core/services/break-point-size/break-point-size.service';
@Component({
    selector: 'global-search',
    templateUrl: './global-search.component.html',
    styleUrls: ['./global-search.component.scss'],
    standalone: true,
})
export class GlobalSearchComponent {
    private _breakPointSizeService = inject(BreakPointSizeService);
    // public label: string = $localize`:@@searchIn:חפש ב` + $localize`:@@yeshivaWebsite:אתר ישיבה`;;
    @Input() placeholder: string = $localize`:@@searchIn:חפש ב` + $localize`:@@yeshivaWebsite:אתר ישיבה`;
    public tooltip: string = $localize`:@@continueOnTheSearchPage:המשכ/י בעמוד החיפוש`;
    public _isFocus: boolean = false;

    //set the fixed filter on the service - can be changed during the component life
    @Input() set isFocus(focus: boolean) {
        this._isFocus = focus;
        if (this._isFocus) {
            this._focusSearchInput();
        }
    }
    @ViewChild('inputRef') inputEl!: ElementRef<HTMLInputElement>;
    constructor() {}

    private _focusSearchInput(): void {
        AppGlobalsModule.setTimeoutIsNotServer(() => {
            if (!this._breakPointSizeService.isMobileSize()) {
                this.inputEl?.nativeElement.focus();
            }
        }, 1);
    }
}
